<template >
    <div class="container">
        <app-facebook-pixel></app-facebook-pixel>
        <app-header></app-header>
        <transition name="flip" mode="out-in">
            <router-view></router-view>
        </transition>
    </div>
</template>

<script>
    import Header     from './components/Header.vue';
    import FacebookPixel from './components/FacebookPixel';

    export default {
        components: {
            AppHeader: Header,
            AppFacebookPixel: FacebookPixel,
        },

        data: function() {
            return {

            }
        },
        computed: {


        },
        methods: {

        },
        created() {

        }
}
</script>

<style>
    .flip-enter {

    }

    .flip-enter-active {
        animation: flip-in 0.3s ease-out forwards;

    }
    .flip-leave {

    }
    .flip-leave-active {
        animation: flip-out 0.3s ease-out forwards;
    }
    @keyframes flip-out {
        from {
            transform: rotateY(0deg);
        }
        to {
            transform: rotateY(90deg);
        }
    }
    @keyframes flip-in {
        from {
            transform: rotateY(90deg);
        }
        to {
            transform: rotateY(0deg);
        }

    }

</style>



// WEBPACK FOOTER //
// src/App.vue